// import moment from "moment";
import requestCFDITimbrar from './request-cfdi-timbrar-idNotaFactura.model';
/**
  * Archivo: itemsStepper-form-values.model.tsx
  *   Autor: Jahaziel Jeuh Baltazar Isidoro <jahaziel.baltazar@finalsoft.com.mx>
  *   Fecha: Septiembre 26, 2023.
*/
export const itemsStepperFormValues = {
  0:{
    fechaVisita: '',
    expediente: '',
    numeroVisita: '',
    montoTotal: '',
  },
  1: new requestCFDITimbrar(),
};
